import { useState } from "react";

import { IconButton, Stack, TextField } from "@bps/fluent-ui";
import { usePermissionsCheckQuery } from "@libs/api/gateways/env/env-gateway.hooks";
import { NO_ACTION_PERMISSION } from "@libs/permissions/permissions.constants";
import { Permissions } from "@libs/permissions/permissions.enum";

import { JobsConfigurationHost } from "../jobs";
import { ConfigValueInputProps } from "./";

interface JobsConfigValueInputProps extends ConfigValueInputProps {}

// Edit control that retains both the TextField and also a cog icon to show the jobs edit dialog
export const JobsConfigValueInput = ({
  value,
  onUpdate,
  isReadOnly
}: JobsConfigValueInputProps) => {
  const { data: hasWritePermission } = usePermissionsCheckQuery(
    Permissions.PltFieldManagementWrite
  );

  const [showDialog, setShowDialog] = useState<boolean>(false);

  return (
    <>
      {showDialog && (
        <JobsConfigurationHost
          onDismiss={() => setShowDialog(false)}
          onUpdate={onUpdate}
          value={value}
        />
      )}
      <Stack
        horizontal
        horizontalAlign="space-between"
        styles={{
          root: { width: "100%" }
        }}
      >
        <TextField
          value={value}
          onChange={(e, value) => onUpdate(value)}
          disabled={isReadOnly || !hasWritePermission}
          title={!hasWritePermission ? NO_ACTION_PERMISSION : undefined}
        />
        {!isReadOnly && (
          <IconButton
            onClick={() => {
              setShowDialog(true);
            }}
            styles={{
              root: {
                background: "transparent"
              }
            }}
            iconProps={{ iconName: "Settings" }}
          />
        )}
      </Stack>
    </>
  );
};
